'use strict';

var PooledSeasonalityInputDataSaveExclusionsModalDirective = function PooledSeasonalityInputDataSaveExclusionsModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/input-data-save-exclusions-modal.html'),
    controller: 'PooledSeasonalityInputDataSaveExclusionsModalController',
    scope: {
      showModal: '=',
      selectedCabin: '@'
    }
  };
};
PooledSeasonalityInputDataSaveExclusionsModalDirective.$inject = [];
module.exports = PooledSeasonalityInputDataSaveExclusionsModalDirective;